
import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function consoleLanguageList(
    console_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/console/${console_id}/language/list${queryString}`
    );
}

export async function consoleLanguageGet(
    item_id: string
) {
    return await clientAxios.get(
        `admin/console/language/${item_id}/show`
    );
}

export async function consoleLanguageCreate(
    console_id: string,
    payload: Partial<any>
) {
    return await clientAxios.post(
        `admin/console/${console_id}/language/create`,
        payload
    );
}

export async function consoleLanguagePatch(
    item_id: string,
    payload: Partial<any>
) {
    return await clientAxios.patch(
        `admin/console/language/${item_id}/patch`,
        { payload }
    );
}

export async function consoleLanguageDel(
    item_id: string,
) {
    return await clientAxios.del(
        `admin/console/language/${item_id}/delete`,
    );
}
